import { render, staticRenderFns } from "./TakipAcIslemDetayView.vue?vue&type=template&id=2d236d75&scoped=true"
import script from "./TakipAcIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./TakipAcIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d236d75",
  null
  
)

export default component.exports